<template>
  <!-- Глиф инструмента "Линия": ломаная со знаком плюс (рисовать линию). -->
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <polyline points="4 20 9 13 13 17 20 9" />
    <circle cx="4" cy="20" r="1.3" fill="currentColor" stroke="none" />
    <circle cx="20" cy="9" r="1.3" fill="currentColor" stroke="none" />
    <path d="M6 3v6M3 6h6" />
  </svg>
</template>
